<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Library</h1>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-lg library">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <div class="inner-title" >
                    <h3>Library</h3>
                   
                </div>
                <div class="text-justify" >
                    <p>The word library is enough to picture you a nicely lit room, well ventilated, well-structured
                        books, journals and magazines. The library at GHRCCST is every bit that and more to it. The fact
                        that it is continuously updated with the latest information in the form of study material, books
                        and reference books pursues the needful.</p>
                    <p>It is an integral part of an educational institution and we have the best in the education arena.
                        We have it organized in the most impeccable manner so as to avail complete nurturing of
                        knowledge to our students. It is the finest learner-centred amenity for our students to cater to
                        with ease.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/library-2.webp" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/library-2.webp" alt="Librabry| Ghrcacsn" title="Librabry| Ghrcacsn">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
        </div>
        <div class="row justify-content-center flex-row-reverse">
            <div class="col-md-8">
                <div class="text-justify" >
                    <p>The aspiring entrepreneurs, the students who want to make their career in IT firms or those with
                        a knack for management need to simply reach out to the library and imbibe the power called
                        ‘knowledge’.</p>
                    <blockquote>“The only thing that you absolutely have to know is the location of the library”- Albert
                        Einstein.</blockquote>
                    <p>And, we have it for our students and faculty right here on the campus of GHRCCST.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/library-1.webp" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/library-1.webp" alt="Librabry| Ghrcacsn" title="Librabry| Ghrcacsn">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
        </div>
        <div class="inner-title" >
            <h5>Our library is embellished with some of the most salient features for you to take advantage of:-</h5>
           
        </div>
        <div class="text-justify" >
            <ul class="list-item">
                <li><strong>Explore length and breadth of the room</strong>- Indeed, with a spacious library like ours;
                    you have immense to look forward to with the facilities. Hence, the first aspect we took care of was
                    to put as many books, learning the material and reading information in the library. Along with it,
                    we have made it really spacious for our students of computer science, management, computer
                    application and administration. So, you can with ease, explore the length and breadth of the room to
                    avail knowledge and education.</li>
                <li><strong>Learning material sees no boundary- </strong> we comprehend your need to study from
                    reference books along with your course books. We understand that you need journals, the books from a
                    variety of authors and the international papers. We have it all with us right here at the library
                    for you to take advantage of.</li>
                <li><strong>Question banks and solutions-</strong> Even when you are prepared verbatim with the notes
                    and books; there is always the need of online question banks and solutions. A pattern of the
                    question paper and a format for an answer is the key to the best-written answer sheets. Undoubtedly,
                    you are well aware of this and so are we.</li>
                <li><strong>Comfortable furniture- </strong> Chairs, tables, lamps we take care of each one of it so
                    that our students are comfortable in the heaven of books. The best quality furniture assures the
                    needful.</li>
                <li><strong> Silence-</strong> Silence is not just a part of the code of conduct; it is religiously
                    followed in our institute library.</li>
                <li><strong>Book bank facility-</strong> The needy, yet meritorious students can avail the Book Bank
                    facility from the library to enrich knowledge and embody information. There are some definite norms
                    for the same for which you can contact the librarian.</li>
            </ul>
            <p>Computer laboratory is for you to explore new depths of academic pursuits. Hence, utilize it with immense
                care. While technology never ceases to be the best friend, make sure you do not make it your enemy by
                misusing it. Do not let it be your worst nightmare.</p>
        </div>
        <marquee direction="left" scrollamount="7" onmouseover="this.stop()" onmouseout="this.start()"
            style="cursor: pointer;">
            <p style="color: #fc822e;"><strong>*Note: - For below link passwords contact to Librarian</strong></p>
        </marquee>
        <div class="inner-title" >
            <h5>The Code of Conduct</h5>
           
        </div>
        <div class="text-justify">
            <p>The library is for you to explore every facet of knowledge, imbibe information and preserve the books. It
                thus becomes your responsibility to take care of books, journals and magazines issued to you. Let the
                flow of information continue. It is opened on the regular college days from 8:00 am to 5:00 pm.</p>
        </div>
        <div class="inner-title" >
            <h5>E- Resources</h5>
           
        </div>
        <h6>Institute has memberships of:</h6>
        <div class="row">
            <div class="col-md-6">
                <h6>DELNET</h6>
               
                <p>DELNET stands for Developing Library Network (formerly Delhi Library Network). It is the first
                    operational library network in India. It was started as a project of the India International Centre
                    in January 1988 with the initial, financial and technical assistance by National Information System
                    for Science and Technology (NISSAT), Department of Scientific and Industrial Research, Govt. of
                    India. It was registered as a society in June 1992 under the Societies Registration Act of 1860 and
                    is currently being promoted by the National Informatics Centre (NIC), Planning Commission, Govt. of
                    India and India International Centre, New Delhi.</p>
                <h6>Link for DELNET login:<a href="http://164.100.247.30/" target="_blank"> http://164.100.247.30/
                    </a><br>User id:<a href="#"> mhghrccst</a></h6>
            </div>
            <div class="col-md-6">
                <h6>National Digital Library</h6>
               
                <p>Ministry of Human Resource Development (MHRD) under its National Mission on Education through
                    Information and Communication Technology (NMEICT) has initiated the National Digital Library of
                    India (NDL India) pilot project to develop a framework of virtual repository of learning resources
                    with a single-window search facility. Filtered and federated searching is employed to facilitate
                    focused searching so that learners can find out the right resource with least effort and in minimum
                    time.</p>
                <h6>Link for National Digital Library Log in: <a href="https://ndl.iitkgp.ac.in/"
                        target="_blank">https://ndl.iitkgp.ac.in/</a><br>Log in id:<a
                        href="mailto:pritam.gedam@raisoni.net">pritam.gedam@raisoni.net</a></h6>
            </div>
        </div>
        <div class="inner-title" >
            <h5>Useful & some open Access links Open Access:</h5>
           
        </div>
        <div class="text-justify" >
            <h6>Link for Shodhganga</h6>
            <p>Shodhgangotri is a an initiative that compliments "ShodhGanga". While "ShodhGanga" is a repository of
                full-text theses submitted to universities in India, Shodhgangotri hosts synopsis of research topic
                submitted to the universities in India by research scholars for registering themselves for the PhD
                programme. Shodhgangotri is now a vibrant project covering not only Research in Progress but also hosts
                Major-Minor Research Project /Post Doctorate Fellowship/Emeritus Fellowship etc. (MRPs/PDFs/Fellowships)
            </p>
            <p>Log in:<a href="https://sg.inflibnet.ac.in/browse?type=title" target="_blank">
                    https://sg.inflibnet.ac.in/browse?type=title</a>
        </div>
        <ul class="list-item" >
            <li>NPTEL Video lectures and web courses:
                <a href="https://nptel.ac.in/" target="_blank">https://nptel.ac.in/</a><br>
                <a href="https://www.iitm.ac.in/content/nptel-open-online-course-noc-0"
                    target="_blank">https://www.iitm.ac.in/content/nptel-open-online-course-noc-0</a>
            </li>
            <li>Online Course Materials, Video Lectures from IIT through NPTEL
                <a href="https://nptel.ac.in/course.html" target="_blank">https://nptel.ac.in/course.html</a>
            </li>
            <li>Free Courses
                <a href="https://www.coursera.org/courses?query=free" target="_blank">
                    https://www.coursera.org/courses?query=free</a>
            </li>
            <li>Free Video Lectures
                <a href="https://freevideolectures.com/" target="_blank">https://freevideolectures.com/</a>
            </li>
        </ul>
        <div class="row mt-3">
            <div class="col-md-6">
                <h6>E-Journals</h6>
               
                <ul class="list-item">
                    <li>DOAJ (Directory of Open Access Journals) <a href="https://doaj.org/" target="_blank">
                            https://doaj.org/</a>
                    </li>
                    <li>Journal of Digital Information <a href="https://journals.tdl.org/jodi/index.php/jodi"
                            target="_blank"> https://journals.tdl.org/jodi/index.php/jodi</a>
                    </li>
                    <li>Free Full-Text Journals on-line <a href="http://www.freefulltext.com"
                            target="_blank">http://www.freefulltext.com</a>
                    </li>
                </ul>
            </div>
            <div class="col-md-6">
                <h6>Dictionary</h6>
               
                <ul class="list-item">
                    <li>E-Dictionary Cambridge Dictionary Online
                        <a href=" http://dictionary.cambridge.org/" target="_blank">
                            http://dictionary.cambridge.org/</a>
                    </li>
                    <li>Subject Dictionary- Technology
                        <a href="http://www.libraryspot.com/dictionaries/"
                            target="_blank">http://www.libraryspot.com/dictionaries/</a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-6">
                <h6>Plagiarism Checking Services (Free Access)</h6>
               
                <ul class="list-item">
                    <li><a href=" http://www.plagiarismsoftware.net" target="_blank">
                            http://www.plagiarismsoftware.net</a>
                    </li>
                    <li><a href="http://smallseotools.com/plagiarism-checker/"
                            target="_blank">http://smallseotools.com/plagiarism-checker/</a>
                    </li>
                    <li>
                        <a href="http://www.plagium.com/" target="_blank">http://www.plagium.com/</a>
                    </li>
                    <li>
                        <a href="http://www.checktext.org/" target="_blank">http://www.checktext.org/</a>
                    </li>
                    <li>
                        <a href="https://www.scanmyeassy.com/" target="_blank">https://www.scanmyeassy.com/</a>
                    </li>
                </ul>
                <h6>Newspapers and Magazines</h6>
                <ul class="list-item">
                    <li><a href="http://www.world-newspapers.com/ " target="_blank">http://www.world-newspapers.com/
                        </a> </li>
                    <li><a href="http://www.onlinenewspapers.com/" target="_blank">http://www.onlinenewspapers.com/</a>
                    </li>
                </ul>
            </div>
            <div class="col-md-6">
                <h6>E-Newspaper</h6>
               
                <ul class="list-item">
                    <li>World Newspaper Directory <a href=" http://www.onlinenewspapers.com/"
                            target="_blank">http://www.onlinenewspapers.com/</a>
                    </li>
                    <li>The Economics Times<a href="https://economictimes.indiatimes.com/"
                            target="_blank">https://economictimes.indiatimes.com/</a>
                    </li>
                    <li>The Hitavada <a href="http://www.ehitavada.com" target="_blank">http://www.ehitavada.com</a>
                    </li>
                    <li>The Times of India <a href="http://www.thetimesofidia.com/"
                            target="_blank">http://www.thetimesofidia.com/</a>
                    </li>
                    <li>The Lokmat <a href="http://www.lokmat.com/" target="_blank">http://www.lokmat.com/</a>
                    </li>
                    <li>Dainik Bhaskar <a href="https://www.bhaskar.com/" target="_blank">https://www.bhaskar.com/</a>
                    </li>
                    <li>Maharashtra Times <a
                            href="https://maharashtratimes.indiatimes.com/others/epaper/articlelist/47415866.cms"
                            target="_blank">https://maharashtratimes.indiatimes.com/others/epaper/articlelist/47415866.cms</a>
                    </li>
                    <li>Sakal <a href="https://www.esakal.com/" target="_blank">https://www.esakal.com/</a>
                    </li>
                    <li>The Hindu <a href="http://www.thehindu.com/news"
                            target="_blank">http://www.thehindu.com/news</a>
                        <a href="http://epaper.thehindu.com/login.php"
                            target="_blank">http://epaper.thehindu.com/login.php</a>
                    </li>
                    <li>Hindu Business <a href="http://epaper.thehindubusinessline.com"
                            target="_blank">http://epaper.thehindubusinessline.com</a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-6">
                <h6>E-Database -Directory of open Access Repository</h6>
               
                <a href="http://www.opendoar.org/" target="_blank">http://www.opendoar.org/</a>
                <h6>E-Books</h6>
               
                <ul class="list-item" >
                    <li>Directory of Open Access books <a href="https://open.umn.edu/opentextbooks/"
                            target="_blank">https://open.umn.edu/opentextbooks/</a>
                    </li>
                    <li>Open Textbook Library <a href="http://smallseotools.com/plagiarism-checker/"
                            target="_blank">http://smallseotools.com/plagiarism-checker/</a>
                    </li>
                    <li>INTECH
                        <a href="https://www.intechopen.com/books" target="_blank">https://www.intechopen.com/books</a>
                    </li>
                </ul>
            </div>
            <div class="col-md-6">
                <h6>E-Books (Management Related)</h6>
               
                Free Management Library<a href="https://managementhelp.org/"
                    target="_blank">https://managementhelp.org/</a>
                <h6>E-Books (Computer Science Related)</h6>
               
                <ul class="list-item" >
                    <li>Free Computer Books<a href="http://freecomputerbooks.com/compscCategory.html"
                            target="_blank">http://freecomputerbooks.com/compscCategory.html</a>
                    </li>
                    <li>Free Tech Books<a href="https://www.freetechbooks.com/"
                            target="_blank">https://www.freetechbooks.com/</a>
                    </li>
                    <li>Free Book Centre
                        <a href="http:www.freebookcentre.net/" target="_blank">http:www.freebookcentre.net/</a>
                    </li>
                    <li>Open Culture
                        <a href="http://www.openculture.com/free-computer-science-textbooks"
                            target="_blank">http://www.openculture.com/free-computer-science-textbooks</a>
                    </li>
                </ul>
            </div>
            <p class="mt-4"> Abhilekh Patal – Portal for Access to Archives & Learning <a
                    href=" https://www.abhilekh-patal.in/jspui/" target="_blank">
                    https://www.abhilekh-patal.in/jspui/</a>
        </div>
    </div>
</section>